<cs-item-group small [title]="LL.intake.goals.lowerBody()">
  <cs-table style="--table-columns: 1fr auto;">
    @for (muscle of lowerBodyMuscles; track muscle.name) {
      <cs-table-row [class.volume-changed]="beforeVolumes && beforeVolumes[muscle.name] !== undefined && beforeVolumes[muscle.name] !== muscle.volume">
        <cs-table-cell>{{ muscle.name }}</cs-table-cell>
        <cs-table-cell>
          @if (beforeVolumes && beforeVolumes[muscle.name] !== undefined && beforeVolumes[muscle.name] !== muscle.volume) {
            {{ beforeVolumes[muscle.name] }} → {{ muscle.volume }} {{ LL.training.trainingProgram.sets() }}
          } @else {
            {{ muscle.volume }} {{ LL.training.trainingProgram.sets() }}
          }
        </cs-table-cell>
      </cs-table-row>
    }
  </cs-table>
</cs-item-group>

<cs-item-group small [title]="LL.intake.goals.upperBody()">
  <cs-table style="--table-columns: 1fr auto;">
    @for (muscle of upperBodyMuscles; track muscle.name) {
      <cs-table-row [class.volume-changed]="beforeVolumes && beforeVolumes[muscle.name] !== undefined && beforeVolumes[muscle.name] !== muscle.volume">
        <cs-table-cell>{{ muscle.name }}</cs-table-cell>
        <cs-table-cell>
          @if (beforeVolumes && beforeVolumes[muscle.name] !== undefined && beforeVolumes[muscle.name] !== muscle.volume) {
            {{ beforeVolumes[muscle.name] }} → {{ muscle.volume }} {{ LL.training.trainingProgram.sets() }}
          } @else {
            {{ muscle.volume }} {{ LL.training.trainingProgram.sets() }}
          }
        </cs-table-cell>
      </cs-table-row>
    }
  </cs-table>
</cs-item-group>
